export const ENABLE_PREFERRED_DAYS = false
